export default __webpack_public_path__ + "static/media/Steve-Thornton.ec698355.jpg";